/* istanbul ignore file */

import { Carriers } from '../constants/carriers';

export abstract class CarrierConfig {
  public abstract getCarrier(): Carriers;
  public abstract getCarrierDisplayName(): string;
  public abstract getLabel(): string;
  public supportLetterGeneration(): boolean {
    return false;
  }
  public getCarrierLogo(): string {
    return '';
  }
  public getLetterFooterText(): string {
    return '';
  }
}
